import { ApprovalStatus, ProcessingStatus } from "Types";

export const isFileInProgress = (processingStatus: ProcessingStatus): boolean =>
  processingStatus.code === "IMPORTING" ||
  processingStatus.code === "PROCESSING" ||
  processingStatus.code === "SECURING";

export const canFileBeDownloaded = (
  processingStatus: ProcessingStatus,
): boolean =>
  processingStatus.code !== "IMPORTING" && processingStatus.code !== "SECURING";

export const isApproved = (approvalStatus: ApprovalStatus): boolean =>
  approvalStatus === "ApprovedAutomatically" || approvalStatus === "Approved";

// Most common extensions in our harvesting dataset
const COMPOUND_EXTENSIONS = new Set([
  "tar.gz",
  "tar.bz2",
  "tar.xz",
  "tar.zst",
  "tar.7z",
  "tar.lz",
  "tar.lzma",
  "tar.z",
  "d.ts",
]);

export const getExtension = (fileName: string): string | null => {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return null;
  }

  const lastSegment = fileName.slice(lastDotIndex + 1);
  // File names can have version numbers, we don't want to display numbers as an extension
  if (/^\d+$/.test(lastSegment)) {
    return null;
  }

  const secondToLastDotIndex = fileName.lastIndexOf(".", lastDotIndex - 1);
  if (secondToLastDotIndex !== -1) {
    const secondSegment = fileName.slice(
      secondToLastDotIndex + 1,
      lastDotIndex,
    );
    const compound = `${secondSegment}.${lastSegment}`;
    if (COMPOUND_EXTENSIONS.has(compound.toLowerCase())) return compound;
  }

  return lastSegment;
};
